import { create } from "zustand";

export const editProfileStore = create((set) => ({
  editProfile: false,

  setEditProfile: (data) => {
    set(() => ({ editProfile: data }));
  },
}));
